import { combineEpics } from 'redux-observable';

import generateOtpEpic from './epics/generateOtp';
import submitOtpEpic from './epics/submitOtp';

export default combineEpics(generateOtpEpic, submitOtpEpic);
